/** The metrics API and the market savings report both build their price-type enum from this list. */
export const HISTORICAL_OFFER_PRICE_TYPES = [
    'list_price',
    'contract_price',
    'quote_price',
    'purchase_price',
    'standard_price',
    'customer_negotiated_price',
    'target_price',
] as const;
